// Sidebar.jsx
import { NavLink } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../../../assets/img/topbar/logo.png";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import { SCHOOL_NAV_ITEMS } from "../config/schoolNavConfig";


const Sidebar = ({ isOpen, closeSidebar, isCollapsed = false }) => {
  const { currentUser } = useTenantAuth();
  const userRole = currentUser?.role_slug;

  const visibleNavItems = SCHOOL_NAV_ITEMS.filter((item) =>
    item.roles.includes(userRole),
  );

  return (
    <div
      className={`sidebar ${isOpen ? "open" : ""} ${isCollapsed ? "collapsed" : ""}`}
    >
      <div className="logo-container">
        <div className="text-center py-3">
          <img src={logo} alt="Logo" className="logo-img" />
        </div>
        <button className="close-sidebar" onClick={closeSidebar}>
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
      <nav className="sidebar-nav">
        {visibleNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? "active" : ""}`
            }
            onClick={closeSidebar}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
